import { render, staticRenderFns } from "./HolidaysForm.vue?vue&type=template&id=8fc97c72&"
import script from "./HolidaysForm.vue?vue&type=script&lang=js&"
export * from "./HolidaysForm.vue?vue&type=script&lang=js&"
import style0 from "./HolidaysForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports